import React from "react";
import * as d3 from 'd3';

import * as dateish from "js/dateish";
import { dayOfYearSpecies, monthOfYearSpecies } from "js/ebird/agg";

import { CalendarYearless } from "web/ui/calendar";
import { Observation } from "js/ebird/ebird";
import { LinkDoY, LinkMoY } from "web/ui/date_link";
import { useAppSelector } from "web/hooks";
import { getObservations } from "web/app_slice";

import classes from './calendar_page.module.css';

const CalendarPage = () => {
  const allObservations = useAppSelector(getObservations);

  const dayColor = getDayColor(allObservations);
  const daily = dayOfYearSpecies(allObservations);
  const monthly = monthOfYearSpecies(allObservations);

  const renderDay = ({ dom, doy }: dateish.CalDay) => {
    const count = daily.get(doy)?.size ?? 0;
    const style = count > 0 ? { backgroundColor: dayColor(count) } : {};
    return <td className={ classes.day } style={ style }>
      <LinkDoY doy={doy}>
        <time className={ classes.day_dom } dateTime={ doy }>{ dom }</time>
        <div className={ classes.day_count}>{ count }</div>
      </LinkDoY>
    </td>
  }
  const renderMonth = (m: dateish.CalMonth) => {
    return <td className={ classes.month } colSpan={7} >
      { `${m.month.name} ` }
      <LinkMoY className='month-count' moy={m.month.mm}>({ monthly.get(m.month.mm)?.size })</LinkMoY>
    </td>
  }

  return <div>
    <CalendarYearless renderDay={ renderDay } renderMonth={ renderMonth } />
  </div>
}

// TODO: This is a selector now
function getDayColor(all: Observation[]) {
  // TODO: Double check that the counts are right
  const daily = dayOfYearSpecies(all);

  // TODO: Figure out a better way to plumb through the colors...
  // Compute a color scale. Any 0 days get "none" and don't impact the scale which I prefer
  // TODO: I want my extent to always have the minimum of 1
  const [, max] = d3.extent(daily.values(), d => d.size) as [number, number];
  const scheme = d3.schemeOrRd[3] as string[];
  const interp = d3.interpolateRgbBasis(scheme);
  return d3.scaleSequential([1, max], interp).unknown("");
}

export default CalendarPage;
